export const DEFAULT_DASHBOARD_WIDGET_BLUEPRINTS = [
    {
        title: "What's Coming Up",
        legacyTitles: ['Overdue Invoices', 'Property Calendar'],
        config: {
            widgetType: 'calendar',
            span: 1,
            preferredView: 'chart',
            dateRange: { pastMonths: 1, futureMonths: 3 },
            status: 'all',
            includeDismissed: false,
            hideCompleted: false,
        },
    },
    {
        title: 'Account Payable Invoices',
        config: {
            widgetType: 'invoice',
            span: 2,
            preferredView: 'list',
        },
    },
    {
        title: 'Budget vs Actual',
        legacyTitles: ['Budget Performance'],
        config: {
            widgetType: 'budget',
            span: 2,
            preferredView: 'chart',
        },
    },
    {
        title: 'Financial Health',
        config: {
            widgetType: 'financial-health',
            span: 1,
            preferredView: 'chart',
        },
    },
    {
        title: 'Money owed to us',
        legacyTitles: ['Account Receivable Risk', 'Accounts Receivable Risk'],
        config: {
            widgetType: 'receivable',
            span: 1,
            preferredView: 'chart',
        },
    },
    {
        title: 'Money we owe',
        legacyTitles: ['Account Payable Risk', 'Accounts Payable Risk'],
        config: {
            widgetType: 'payable',
            span: 1,
            preferredView: 'chart',
        },
    },
    {
        title: 'Occupancy',
        legacyTitles: ['Unit Information'],
        config: {
            widgetType: 'unit',
            span: 1,
            preferredView: 'chart',
        },
    },
    {
        title: 'Operating Income',
        config: {
            widgetType: 'operating-income',
            span: 1,
            preferredView: 'chart',
        },
    },
    {
        title: 'Operating Expenses',
        config: {
            widgetType: 'operating-expenses',
            span: 1,
            preferredView: 'chart',
        },
    },
];
export const DEFAULT_DASHBOARD_WIDGET_TYPES = new Set(DEFAULT_DASHBOARD_WIDGET_BLUEPRINTS.map((widget) => widget.config.widgetType));
export function getDefaultDashboardWidgetBlueprintByType(widgetType) {
    return DEFAULT_DASHBOARD_WIDGET_BLUEPRINTS.find((widget) => widget.config.widgetType === widgetType);
}
function getBlueprintAcceptedTitles(blueprint) {
    const legacyTitles = 'legacyTitles' in blueprint ? blueprint.legacyTitles : [];
    return [blueprint.title, ...legacyTitles];
}
export function canContinueBoardMemberDashboardBootstrap(widgets) {
    const widgetTypes = widgets.map((widget) => widget.widgetType);
    const uniqueWidgetTypes = new Set(widgetTypes);
    return (widgetTypes.every((widgetType) => DEFAULT_DASHBOARD_WIDGET_TYPES.has(widgetType)) &&
        uniqueWidgetTypes.size === widgetTypes.length &&
        uniqueWidgetTypes.size < DEFAULT_DASHBOARD_WIDGET_TYPES.size);
}
export function matchesDefaultDashboardBootstrapWidget(widget) {
    const blueprint = getDefaultDashboardWidgetBlueprintByType(widget.config.widgetType);
    if (!blueprint)
        return false;
    if (!getBlueprintAcceptedTitles(blueprint).includes(widget.title))
        return false;
    if (widget.config.widgetType === 'calendar' && blueprint.config.widgetType === 'calendar') {
        return (widget.config.span === blueprint.config.span &&
            widget.config.entityInput === undefined &&
            widget.config.types === undefined &&
            widget.config.status === blueprint.config.status &&
            widget.config.search === undefined &&
            widget.config.includeDismissed === blueprint.config.includeDismissed &&
            widget.config.hideCompleted === blueprint.config.hideCompleted &&
            widget.config.dateRange?.pastMonths === blueprint.config.dateRange.pastMonths &&
            widget.config.dateRange?.futureMonths === blueprint.config.dateRange.futureMonths);
    }
    if ('entityInput' in widget.config && widget.config.entityInput !== undefined)
        return false;
    return widget.config.span === blueprint.config.span;
}
//# sourceMappingURL=dashboardWidgets.js.map